// extracted by mini-css-extract-plugin
export default {"root":"VMatchStatistics_root_hRCK9","separator":"VMatchStatistics_separator_DKC0w"};